import { render, staticRenderFns } from "./setOrResetDialog.vue?vue&type=template&id=740fd008&scoped=true&"
import script from "./setOrResetDialog.vue?vue&type=script&lang=js&"
export * from "./setOrResetDialog.vue?vue&type=script&lang=js&"
import style0 from "./setOrResetDialog.vue?vue&type=style&index=0&id=740fd008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740fd008",
  null
  
)

export default component.exports